import { render, staticRenderFns } from "./SalonFooter.vue?vue&type=template&id=0a42925e&scoped=true"
import script from "./SalonFooter.vue?vue&type=script&lang=js"
export * from "./SalonFooter.vue?vue&type=script&lang=js"
import style0 from "./SalonFooter.vue?vue&type=style&index=0&id=0a42925e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a42925e",
  null
  
)

export default component.exports